import { QueryFn, MutationFn } from '@percent/grants-nomination-form/hooks';
import { GetNominationFormResponse, GetNominationFormParams, SubmitNominationFormParams } from './nominationForm.types';
import { DEFAULT_LOCALE } from '@percent/grants-nomination-form/i18n/resources';
import { mapSupportedLocales } from '@percent/grants-nomination-form/i18n/utils/mapSupportedLocales';

export const getNominationFormAction: QueryFn<[string, GetNominationFormParams], GetNominationFormResponse> = async (
  client,
  [_, { programId, locale = DEFAULT_LOCALE }],
) => {
  const response = await client.get(`v1/grants/programs/${programId}/nomination-form`, {
    params: { locale: mapSupportedLocales(locale) },
  });

  return response.data;
};

export const submitNominationFormAction: MutationFn<SubmitNominationFormParams, void> = async (
  client,
  { programId, data, locale = DEFAULT_LOCALE },
) => {
  await client.post<void>(`v1/grants/programs/${programId}/nominations`, {
    ...data,
    locale: mapSupportedLocales(locale),
  });
};
